"use client";

import { useAdminViewer } from "./use-admin-viewer";
import { canOpenAdminHref } from "@shared/auth/access";

export function isAdminHref(href: string): boolean {
  return href === "/admin" || href.startsWith("/admin/") || href.startsWith("/admin?") || href.startsWith("/admin#");
}

export function useCanOpenHref(): (href: string | undefined) => boolean {
  const viewer = useAdminViewer();
  return (href) => href !== undefined && (!isAdminHref(href) || canOpenAdminHref(viewer, href));
}

export function useOpenableHref(href: string | undefined): string | undefined {
  const canOpen = useCanOpenHref();
  return canOpen(href) ? href : undefined;
}
